/**
 * Unwraps an API response that may be wrapped in a `{ data: ... }` envelope.
 *
 * Global helper — many feature API modules historically declared their own
 * local copy of this logic; prefer importing from here going forwards.
 */
export const unwrap = <T>(responseData: unknown): T => {
	if (responseData && typeof responseData === "object" && "data" in responseData) {
		return (responseData as Record<string, unknown>).data as T;
	}
	return responseData as T;
};
